import { ImportButton } from '@components/Buttons/ImportButton';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { Main } from '@components/Main';
import { PageContent } from '@components/PageContent';
import { PageTitle, PageTitleText } from '@components/PageTitle';
import { TableWrapper } from '@components/Table/TableWrapper';
import { useData } from '@hooks/useData';
import { useEffectOnce } from '@hooks/useEffectOnce';
import { useField } from '@hooks/useField';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { useModalWindow } from '@hooks/useModalWindow';
import { EnumSortDirection } from '@hooks/useRequest';
import { IConta } from '@model/Conta';
import { EnumEmpresa, useEmpresaCombo } from '@model/Empresa';
import { EnumOperadora, useOperadoraCombo } from '@model/Operadora';
import { IContaFilter, useContaService } from '@services/ContaService';
import React, { useState } from 'react';
import { ContaFilter } from './ContaFilter';
import { ContaImportarModal } from './ContaImportarModal';
import { ContaTable } from './ContaTable';
import { useLinhaService } from '@services/LinhaService';

export type ContaProps = {

}

export function Conta (props: ContaProps) {
    const [numerosContrato, setNumerosContrato] = useState<string[]>([]);

    const loading = useLoading();
    const message = useMessage();

    const contaService = useContaService();
    const linhaService = useLinhaService();

    const empresaCombo = useEmpresaCombo();

    const importarModal = useModalWindow();

    const data = useData<IConta, IContaFilter>({
        filter: {
            empresaId: useField(EnumEmpresa.None),
            numeroContrato: useField(),
            competencia: useField()
        },

        sortField: {
            name: "contaId",
            direction: EnumSortDirection.Desc
        }
    });

    React.useEffect(() => {
        if (!loading.isLoading) {
            loading.start();
            contaService.listar(data.requestedData)
                .then(data.handleResultResponse)
                .catch(message.showException)
                .finally(loading.stop);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.requestedData]);

    const loadNumerosContrato = () => {
        linhaService.listarNumerosContrato()
            .then(response => {
                setNumerosContrato(response.data);
            })
            .catch(message.showException)
            .finally();
    }
    
    useEffectOnce(() => {
        empresaCombo.loadOptions();
        loadNumerosContrato();
    })

    return (
        <Main>
            <PageTitle>
                <HorizontalGrid>
                    <GridItem>
                        <PageTitleText text="Contas" />
                    </GridItem>
                    <GridItem floatRight>
                        <ImportButton onClick={importarModal.open} />
                    </GridItem>
                </HorizontalGrid>
            </PageTitle>
            
            <PageContent>
                <ContaFilter 
                    filter={data.filter}
                    isLoading={loading.isLoading}
                    empresaCombo={empresaCombo}
                    numerosContrato={numerosContrato}
                />

                <TableWrapper>
                    <ContaTable 
                        data={data}
                        isLoading={loading.isLoading}
                    />
                </TableWrapper>

                <ContaImportarModal 
                    modal={importarModal}
                    empresaCombo={empresaCombo}
                    numerosContrato={numerosContrato}
                />
            </PageContent>
        </Main>
    )
}